import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

// COMMONS DIRECTIVES
import { DirectivesModule } from '@commons/directives';

// COMMONS
import { CommonsComponentsModule } from '@commons/components';

// COMPONENTS
import { TemplatePage } from './template.page';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    DirectivesModule,
    CommonsComponentsModule,
    RouterModule.forChild([
      {
        path: '',
        component: TemplatePage,
      },
    ]),
  ],
  declarations: [TemplatePage],
})
export class TemplatePageModule {}
